import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const getEditorViewPluginKey = new PluginKey('aiExperienceGetEditorView');
